import {createReducer} from '@reduxjs/toolkit'
import {getMyTickets} from '../actions/tickets'

const defaultState = {}

export const tickets = createReducer(defaultState, builder => {
  builder.addCase(getMyTickets.fulfilled, (state, action) => {
    state[action.meta.arg.eventId] = action.payload.tickets
  })
})
